<div *transloco="let t; read: 'bp'" class="dialogHeight px-2 flex flex-col justify-between">
    <master-process-selection-tree
        [processes]="systemBPLS()"
        (onTreeNodeSelectionChanged)="
            onTreeNodeSelectionChanged($event)
        "></master-process-selection-tree>

    <div class="flex flex-row gap-2 justify-end">
        <button mat-button (click)="cancel()">
            {{ t('cancel') }}
        </button>
        <button
            mat-raised-button
            [disabled]="!selectedId()"
            color="primary"
            (click)="createProcessCopy()">
            {{ t('createCopy') }}
        </button>
        <button
            mat-raised-button
            color="primary"
            [disabled]="!selectedId()"
            (click)="createProcessLink()">
            {{ t('createLink') }}
        </button>
    </div>
</div>
